import React from "react";
import mock01 from '../assets/images/IFSBroker.jpeg';
import mock02 from '../assets/images/hsb.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import '../assets/styles/Project.scss';


function Project() {
    return(
    <div className="projects-container" id="projects">
        <h2 className="section-heading">Personal Projects</h2>
        <div className="projects-grid">
            <div className="project">
                <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><img src={mock04} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><h3 className="project-title">Multiple Regression Property Analysis</h3></a>
                <p>Analyzed the real estate market in Japan and predicted property prices by implementing statistical methods such as OLS and multi-regression analysis. This project leveraged Python and various libraries such as Pandas, NumPy, Matplotlib, and Scikit-Learn.</p>
            </div>
            <div className="project">
                <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><img src={mock03} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><h3 className="project-title">Programs of Study</h3></a>
                <p>Designed and developed a custom component for a CMS-based platform (e.g., 'Brightspot') using Java, Handlebars, and LESS. University students can find their majors of interest through this module.</p>
            </div>
            <div className="project">
                <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><img src={mock02} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><h3 className="project-title">Data Scientist Graduate</h3></a>
                <p>Completed a Certificate of Advanced Studies (CAS) in Data Science with a strong focus on statistical analysis, machine learning, and data-driven problem solving. The program provided hands-on experience in handling real-world datasets, applying modern analytical tools, and developing practical solutions for business and industrial challenges.</p>
            </div>
            <div className="project">
                <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><img src={mock01} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><h3 className="project-title">IFS Broker Certification</h3></a>
                <p>Proven expertise in coordinating and documenting IFS Broker certification processes, ensuring compliance with international quality standards and food safety regulations.</p>
            </div>
        </div>
    </div>
    );
}

export default Project;